module.exports = __webpack_public_path__ + "images/skewness-09-desktop.png";